import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop
 * - Takes over the browser's native scrollRestoration so our scroll logic always wins.
 * - On any navigation (PUSH / REPLACE / POP / back / forward), jumps to the top
 *   of the page unless the URL has a #hash (anchor).
 * - Uses requestAnimationFrame to override any delayed browser restoration.
 */
const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      try { window.history.scrollRestoration = 'manual'; } catch (_) {}
    }
  }, []);

  useEffect(() => {
    // If URL points to a #section, let the browser (or page) handle it
    if (hash) return;

    const scrollNow = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch (_) {
        window.scrollTo(0, 0);
      }
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };

    // Run immediately AND after the next frame to beat the browser's
    // async scroll restoration on POP (back/forward) navigations.
    scrollNow();
    requestAnimationFrame(scrollNow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, key, navType]);

  return null;
};

export default ScrollToTop;
